<template>
  <layout>
    <div class="quantify-page">
      <!-- ========== 量化交易的本质 模块 ========== -->
      <div class="essence-section">
        <div class="container">
          <div class="essence-content">
            <h1 class="essence-title">
              {{ $t('quantPage.essence.title1') }}<span class="highlight">{{ $t('quantPage.essence.titleHl') }}</span>
            </h1>
            <p class="essence-desc">
              {{ $t('quantPage.essence.desc') }}
            </p>
            <div class="essence-visual">
              <div class="frame-container"></div>
              <div class="feature-card card-trend">
                <div class="card-icon-wrap">
                  <img src="@/assets/images/bg/yczs.png" alt="预测走势" />
                </div>
                <span class="card-text">{{ $t('quantPage.essence.trend') }}</span>
              </div>
              <div class="feature-card card-factor">
                <div class="card-icon-wrap">
                  <img src="@/assets/images/bg/yzfx.png" alt="因子分析" />
                </div>
                <span class="card-text">{{ $t('quantPage.essence.factor') }}</span>
              </div>
              <div class="feature-card card-auto">
                <div class="card-icon-wrap">
                  <img src="@/assets/images/bg/zdjy.png" alt="自动交易" />
                </div>
                <span class="card-text">{{ $t('quantPage.essence.auto') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 量化投资策略模块 -->
      <div class="strategy-section">
        <div class="container">
          <div class="strategy-header">
            <div class="strategy-tag">{{ $t('quantPage.strategy.tag') }}</div>
            <h2 class="strategy-title">{{ $t('quantPage.strategy.title') }}</h2>
            <p class="strategy-subtitle">
              {{ $t('quantPage.strategy.subtitle') }}
            </p>
          </div>
          <div class="strategy-cards strategy-carousel">
            <div class="strategy-viewport">
              <div class="strategy-track" :style="{ transform: 'translateX(-' + strategyIndex * 100 + '%)' }">
                <div class="strategy-card">
                  <div class="strategy-icon">
                    <img src="@/assets/images/icons/容器.png" alt="">
                  </div>
                  <h3 class="card-title">{{ $t('quantPage.strategy.card1Title') }}</h3>
                  <p class="card-desc">{{ $t('quantPage.strategy.card1Desc') }}</p>
                </div>
                <div class="strategy-card card-highlight">
                  <div class="strategy-icon">
                    <img src="@/assets/images/icons/容器 (5).png" alt="">
                  </div>
                  <h3 class="card-title">{{ $t('quantPage.strategy.card2Title') }}</h3>
                  <p class="card-desc">{{ $t('quantPage.strategy.card2Desc') }}</p>
                </div>
                <div class="strategy-card">
                  <div class="strategy-icon">
                    <img src="@/assets/images/icons/容器 (1).png" alt="">
                  </div>
                  <h3 class="card-title">{{ $t('quantPage.strategy.card3Title') }}</h3>
                  <p class="card-desc">{{ $t('quantPage.strategy.card3Desc') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 产品矩阵模块 -->
      <div class="product-matrix-section">
        <div class="container">
          <h2 class="matrix-title">{{ $t('quantPage.matrix.title') }}</h2>

          <div class="matrix-tabs">
            <div class="matrix-tab" :class="{ active: activeMatrixTab === 0 }" @click="activeMatrixTab = 0">
              {{ $t('quantPage.matrix.tab1') }}
            </div>
            <div class="matrix-tab" :class="{ active: activeMatrixTab === 1 }" @click="activeMatrixTab = 1">
              {{ $t('quantPage.matrix.tab2') }}
            </div>
            <div class="matrix-tab" :class="{ active: activeMatrixTab === 2 }" @click="activeMatrixTab = 2">
              {{ $t('quantPage.matrix.tab3') }}
            </div>
          </div>

          <div class="matrix-content">
            <!-- 产品内容 1 -->
            <div v-if="activeMatrixTab === 0" class="matrix-panel forex-panel">
              <div class="panel-left">
                <h3 class="panel-title">{{ $t('quantPage.p1.title') }}</h3>
                <p class="panel-subtitle">{{ $t('quantPage.p1.subtitle') }}</p>
                <ul class="panel-features">
                  <li>{{ $t('quantPage.p1.f1') }}</li>
                  <li>{{ $t('quantPage.p1.f2') }}</li>
                  <li>{{ $t('quantPage.p1.f3') }}</li>
                  <li>{{ $t('quantPage.p1.f4') }}</li>
                </ul>
              </div>
              <div class="panel-right">
                <div class="chart-card">
                  <div class="chart-header">
                    <div class="chart-icon">
                      <img src="@/assets/images/icons/pjsy.png" alt="平均收益率"
                        style="width: 36px; height: 36px; border-radius: 50%" />
                    </div>
                    <div>
                      <div class="chart-title">{{ $t('quantPage.chart.title') }}</div>
                      <div class="chart-subtitle">{{ $t('quantPage.chart.subtitle') }}</div>
                    </div>
                  </div>
                  <div class="chart-stats-top" style="min-width: 200px; padding: 16px 20px">
                    <div class="stat-item">
                      <span class="stat-label">{{ $t('quantPage.chart.annual') }}</span>
                      <span class="stat-dots">
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span>
                      </span>
                      <span class="stat-value yellow">{{ $t('quantPage.chart.annualVal1') }}</span>
                    </div>
                    <div class="stat-item">
                      <span class="stat-label">{{ $t('quantPage.chart.monthly') }}</span>
                      <span class="stat-dots">
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span>
                      </span>
                      <span class="stat-value yellow">{{ $t('quantPage.chart.monthlyVal1') }}</span>
                    </div>
                  </div>
                  <div class="chart-image">
                    <img src="@/assets/images/bg/Vector 8.png" alt="外汇收益走势图" />
                  </div>
                  <div class="chart-stats-bottom">
                    <div class="stat-box" style="width: 150px; height: 100px">
<div class="stat-box-value" style="font-size: 24px">{{ $t('quantPage.chart.minInvestVal1') }}</div>
                      <div class="stat-box-label" style="font-size: 16px">{{ $t('quantPage.chart.minInvest') }}</div>
                    </div>
                    <div class="stat-box"
                      style="width: 200px; height: 130px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                      <div class="stat-box-label" style="font-size: 20px">{{ $t('quantPage.chart.lossProb') }}</div>
                      <div class="stat-box-sublabel" style="font-size: 14px">{{ $t('quantPage.chart.lossProbSub') }}</div>
                      <div class="stat-box-value small" style="font-size: 28px">0.02793%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 产品内容 2 -->
            <div v-if="activeMatrixTab === 1" class="matrix-panel forex-panel">
              <div class="panel-right">
                <div class="chart-card">
                  <div class="chart-header">
                    <div class="chart-icon">
                      <img src="@/assets/images/icons/pjsy.png" alt="平均收益率"
                        style="width: 36px; height: 36px; border-radius: 50%" />
                    </div>
                    <div>
                      <div class="chart-title">{{ $t('quantPage.chart.title') }}</div>
                      <div class="chart-subtitle">{{ $t('quantPage.chart.subtitle') }}</div>
                    </div>
                  </div>
                  <div class="chart-stats-top" style="min-width: 200px; padding: 16px 20px">
                    <div class="stat-item">
                      <span class="stat-label">{{ $t('quantPage.chart.annual') }}</span>
                      <span class="stat-dots">
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span>
                      </span>
                      <span class="stat-value yellow">{{ $t('quantPage.chart.annualVal2') }}</span>
                    </div>
                    <div class="stat-item">
                      <span class="stat-label">{{ $t('quantPage.chart.monthly') }}</span>
                      <span class="stat-dots">
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span>
                      </span>
                      <span class="stat-value yellow">{{ $t('quantPage.chart.monthlyVal2') }}</span>
                    </div>
                  </div>
                  <div class="chart-image">
                    <img src="@/assets/images/bg/Vector 8 (2).png" alt="套利收益走势图" />
                  </div>
                  <div class="chart-stats-bottom">
                    <div class="stat-box" style="width: 150px; height: 100px">
<div class="stat-box-value" style="font-size: 24px">{{ $t('quantPage.chart.minInvestVal2') }}</div>
                      <div class="stat-box-label" style="font-size: 16px">{{ $t('quantPage.chart.minInvest') }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel-left">
                <h3 class="panel-title">{{ $t('quantPage.p2.title') }}</h3>
                <p class="panel-subtitle">{{ $t('quantPage.p2.subtitle') }}</p>
                <ul class="panel-features">
                  <li>{{ $t('quantPage.p2.f1') }}</li>
                  <li>{{ $t('quantPage.p2.f2') }}</li>
                  <li>{{ $t('quantPage.p2.f3') }}</li>
                </ul>
              </div>
            </div>

            <!-- 产品内容 3 -->
            <div v-if="activeMatrixTab === 2" class="matrix-panel forex-panel">
              <div class="panel-left">
                <h3 class="panel-title">{{ $t('quantPage.p3.title') }}</h3>
                <p class="panel-subtitle">{{ $t('quantPage.p3.subtitle') }}</p>
                <ul class="panel-features">
                  <li>{{ $t('quantPage.p3.f1') }}</li>
                  <li>{{ $t('quantPage.p3.f2') }}</li>
                  <li>{{ $t('quantPage.p3.f3') }}</li>
                </ul>
              </div>
              <div class="panel-right">
                <div class="chart-card">
                  <div class="chart-header">
                    <div class="chart-icon">
                      <img src="@/assets/images/icons/pjsy.png" alt="平均收益率"
                        style="width: 36px; height: 36px; border-radius: 50%" />
                    </div>
                    <div>
                      <div class="chart-title">{{ $t('quantPage.chart.title') }}</div>
                      <div class="chart-subtitle">{{ $t('quantPage.chart.subtitle') }}</div>
                    </div>
                  </div>
                  <div class="chart-stats-top" style="min-width: 200px; padding: 16px 20px">
                    <div class="stat-item">
                      <span class="stat-label">{{ $t('quantPage.chart.annual') }}</span>
                      <span class="stat-dots">
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span>
                      </span>
                      <span class="stat-value yellow">{{ $t('quantPage.chart.annualVal3') }}</span>
                    </div>
                    <div class="stat-item">
                      <span class="stat-label">{{ $t('quantPage.chart.monthly') }}</span>
                      <span class="stat-dots">
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                        <span class="dot"></span>
                      </span>
                      <span class="stat-value yellow">{{ $t('quantPage.chart.monthlyVal3') }}</span>
                    </div>
                  </div>
                  <div class="chart-image">
                    <img src="@/assets/images/bg/Vector 8 (1).png" alt="期权收益走势图" />
                  </div>
                  <div class="chart-stats-bottom">
                    <div></div>
                    <div class="stat-box" style="width: 150px; height: 100px">
<div class="stat-box-value" style="font-size: 24px">{{ $t('quantPage.chart.minInvestVal3') }}</div>
                      <div class="stat-box-label" style="font-size: 16px">{{ $t('quantPage.chart.minInvest') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="matrix-navs">
              <div class="matrix-nav prev" @click="prevMatrixTab">
                <img src="@/assets/images/icons/icon_left.png" alt="上一个" />
              </div>
              <div class="matrix-nav next" @click="nextMatrixTab">
                <img src="@/assets/images/icons/icon_right.png" alt="下一个" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ========== 合作模式模块（按钮在卡片内部） ========== -->
      <div class="cooperation-section">
        <div class="container">
          <div class="cooperation-header">
            <span class="cooperation-tag">{{ $t('quantPage.coop.tag') }}</span>
            <h2 class="cooperation-title">{{ $t('quantPage.coop.title') }}</h2>
          </div>

          <div class="cooperation-cards-wrapper">
            <!-- 第一张卡片 - 资金安全保障，始终显示 -->
            <div class="cooperation-card card-security" v-show="visibleCards >= 1">
              <div class="card-bg-overlay"></div>
              <div class="cooperation-card-content">
                <div class="security-left">
                  <div class="security-header">
                    <img src="@/assets/images/bg/Group 1000005946.png" alt="向下箭头" />
                    <h3 class="cooperation-card-title security-icon-wrap-title">{{ $t('quantPage.coop.c1Title') }}</h3>
                  </div>
                  <ul class="security-list">
                    <li>
                      <span class="num">1</span>
                      <div class="text">
                        <strong>{{ $t('quantPage.coop.c1i1t') }}</strong>
                        <p>{{ $t('quantPage.coop.c1i1d') }}</p>
                      </div>
                    </li>
                    <li>
                      <span class="num">2</span>
                      <div class="text">
                        <strong>{{ $t('quantPage.coop.c1i2t') }}</strong>
                        <p>{{ $t('quantPage.coop.c1i2d') }}</p>
                      </div>
                    </li>
                    <li>
                      <span class="num">3</span>
                      <div class="text">
                        <strong>{{ $t('quantPage.coop.c1i3t') }}</strong>
                        <p>{{ $t('quantPage.coop.c1i3d') }}</p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="security-right">
                  <img src="@/assets/images/bg/组 2544.png" alt="" />
                </div>
              </div>
              <div class="cooperation-more-wrap">
                <img class="cooperation-more-icon" src="@/assets/images/icons/组件 151.png" alt="">
                <button class="cooperation-more-btn" @click="handleMoreClick">{{ $t('quantPage.coop.more1') }}</button>
              </div>
            </div>

            <!-- 第二张卡片 - 全天候陪伴式辅导 (已同步样式) -->
            <div class="cooperation-card card-support" v-show="visibleCards >= 2">
              <div class="card-bg-overlay"></div>
              <div class="cooperation-card-content">
                <div class="security-left">
                  <div class="security-header">
                    <img src="@/assets/images/bg/Group 1000005946 (1).png" alt="向下箭头" />
                    <h3 class="cooperation-card-title security-icon-wrap-title">{{ $t('quantPage.coop.c2Title') }}</h3>
                  </div>
                  <ul class="security-list">
                    <li>
                      <span class="num">1</span>
                      <div class="text">
                        <strong>{{ $t('quantPage.coop.c2i1t') }}</strong>
                        <p>{{ $t('quantPage.coop.c2i1d') }}</p>
                      </div>
                    </li>
                    <li>
                      <span class="num">2</span>
                      <div class="text">
                        <strong>{{ $t('quantPage.coop.c2i2t') }}</strong>
                        <p>{{ $t('quantPage.coop.c2i2d') }}</p>
                      </div>
                    </li>
                    <li>
                      <span class="num">3</span>
                      <div class="text">
                        <strong>{{ $t('quantPage.coop.c2i3t') }}</strong>
                        <p>{{ $t('quantPage.coop.c2i3d') }}</p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="security-right">
                  <img src="@/assets/images/bg/image.png" alt="" />
                </div>
              </div>
              <div class="cooperation-more-wrap">
                <img class="cooperation-more-icon" src="@/assets/images/icons/组件 151.png" alt="">
                <button class="cooperation-more-btn" @click="handleMoreClick">{{ $t('quantPage.coop.more2') }}</button>
              </div>
            </div>

            <!-- 第三张卡片 - 阳光分润机制 (已同步样式) -->
            <div class="cooperation-card card-profit" v-show="visibleCards >= 3">
              <div class="card-bg-overlay"></div>
              <div class="cooperation-card-content">
                <div class="security-left">
                  <div class="security-header">
                    <img src="@/assets/images/bg/Group 1000005946 (2).png" alt="向下箭头" />
                    <h3 class="cooperation-card-title security-icon-wrap-title">{{ $t('quantPage.coop.c3Title') }}</h3>
                  </div>
                  <ul class="security-list">
                    <li>
                      <span class="num">1</span>
                      <div class="text">
                        <strong>{{ $t('quantPage.coop.c3i1t') }}</strong>
                        <p>{{ $t('quantPage.coop.c3i1d') }}</p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="security-right">
                  <img src="@/assets/images/bg/Group 1000005947.png" alt="" />
                </div>
              </div>
              <div class="cooperation-more-wrap">
                <img class="cooperation-more-icon" src="@/assets/images/icons/组件 151.png" alt="">
                <button class="cooperation-more-btn" @click="handleMoreClick">{{ $t('quantPage.coop.more2') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ========== 投资理念模块 ========== -->
      <div class="investment-philosophy-section" style="margin: 200px 0;">
        <div class="container">
          <div class="strategy-header">
            <div class="strategy-tag">{{ $t('quantPage.philo.tag') }}</div>
            <h2 class="strategy-title">{{ $t('quantPage.philo.title') }}</h2>
            <p class="strategy-subtitle">
              {{ $t('quantPage.philo.subtitle') }}
            </p>
          </div>

          <div class="strategy-cards philo-carousel">
            <div class="philo-viewport">
            <div class="philo-track" :style="{ transform: 'translateX(-' + philoIndex * 100 + '%)' }">
            <div class="strategy-card">
              <div class="strategy-icon">
                <img src="@/assets/images/icons/容器 (2).png" alt="">
              </div>
              <h3 class="card-title">{{ $t('quantPage.philo.card1Title') }}</h3>
              <p class="card-desc">{{ $t('quantPage.philo.card1Desc') }}</p>
            </div>

            <div class="strategy-card card-highlight">
              <div class="strategy-icon">
                <img src="@/assets/images/icons/容器 (3).png" alt="">
              </div>
              <h3 class="card-title">{{ $t('quantPage.philo.card2Title') }}</h3>
              <p class="card-desc">{{ $t('quantPage.philo.card2Desc') }}</p>
            </div>

            <div class="strategy-card">
              <div class="strategy-icon">
                <img src="@/assets/images/icons/容器 (4).png" alt="">
              </div>
              <h3 class="card-title">{{ $t('quantPage.philo.card3Title') }}</h3>
              <p class="card-desc">{{ $t('quantPage.philo.card3Desc') }}</p>
            </div>
            </div>
            </div>
          </div>
        </div>
      </div>

      <report-modal />

      <!-- ========== 信任与行动模块 ========== -->
      <div class="trust-cta-section">
        <div class="container" style="height: 100%;">
          <div class="trust-cta-content">
            <h2 class="trust-cta-title">
              <span class="highlight">{{ $t('quantPage.trust.titlePre') }}</span>{{ $t('quantPage.trust.titlePost') }}
            </h2>
            <h2 class="trust-cta-title" style="  color: #ffd200;"><span>{{ $t('quantPage.trust.title2') }}</span> </h2>
            <div class="trust-cta-btn-wrap">
              <button class="trust-cta-btn" @click="handleJoinClick">{{ $t('quantPage.trust.btn') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Pagination from "@/components/pagination/pagination";
import BlogCard from "@/components/blog/BlogCard1";
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import Layout from "@/components/layouts/Layout";
import SalScrollAnimationMixin from "@/mixins/SalScrollAnimationMixin";
import BlogMixin from "@/mixins/BlogMixin";
import image1 from "@/assets/images/bg/hdp1.png";
import image2 from "@/assets/images/bg/hdp2.png";
import image3 from "@/assets/images/bg/hdp3.png";
import image4 from "@/assets/images/bg/hdp4.png";
import BlogPagination from "@/components/pagination/BlogPagination";
import BlogSidebar from "@/components/blog/BlogSidebar";
import FadeCarousel from "../home/FadeCarousel ";
export default {
  name: "BlogSingleColumn",
  components: {
    BlogSidebar,
    BlogPagination,
    Pagination,
    BlogCard,
    Breadcrumb,
    Layout,
    FadeCarousel,
  },
  mixins: [SalScrollAnimationMixin, BlogMixin],
  data() {
    return {
      filteredRows: [
        { image: image1, description: "details", title: "Trading Data Position Display Exhibition" },
        { image: image2, description: "flow chart", title: "AI quantitative trading framework" },
        { image: image3, description: "statistical chart", title: "Comparison of Matrix Power AI Quantitative Strategy and Mainstream Market Return Rate from January 2023 to June 2025" },
        { image: image4, description: "statistical chart", title: "Index DetailsIndex Details" },
      ],
      pageStart: "",
      countOfPage: "",
      activeMatrixTab: 0,
      visibleCards: 1, // 当前显示的卡片数量，初始为1
      strategyIndex: 0, // H5 量化投资策略卡片轮播索引
      philoIndex: 0, // H5 投资理念卡片轮播索引
    };
  },
  methods: {
    paginatedData(filteredRows, pageStart, countOfPage) {
      this.filteredRows = filteredRows;
      this.pageStart = pageStart;
      this.countOfPage = countOfPage;
    },
    prevMatrixTab() {
      this.activeMatrixTab = (this.activeMatrixTab - 1 + 3) % 3;
    },
    nextMatrixTab() {
      this.activeMatrixTab = (this.activeMatrixTab + 1) % 3;
    },
    // H5 量化投资策略卡片自动轮播（循环切换）
    nextStrategy() {
      this.strategyIndex = (this.strategyIndex + 1) % 3;
    },
    // H5 投资理念卡片自动轮播（循环切换）
    nextPhilo() {
      this.philoIndex = (this.philoIndex + 1) % 3;
    },
    handleMoreClick() {
      if (this.visibleCards >= 3) {
        this.visibleCards = 1;
      } else {
        this.visibleCards += 1;
      }
    },
    // 立即加入按钮点击处理
    handleJoinClick() {
      console.log('立即加入 clicked');
      // 可在此添加跳转或弹窗逻辑
      // this.$router.push('/contact');
    },
  },
  mounted() {
    // H5/平板 量化投资策略 + 投资理念卡片自动轮播：3 秒/张，≤991px 生效（桌面保持三栏并复位索引）
    this.strategyTimer = setInterval(() => {
      if (window.innerWidth <= 991) {
        this.nextStrategy();
        this.nextPhilo();
      } else {
        this.strategyIndex = 0;
        this.philoIndex = 0;
      }
    }, 3000);
  },
  beforeDestroy() {
    clearInterval(this.strategyTimer);
  },
};
</script>
<style scoped lang="scss">
$bg-dark: #0f172a;
$bg-primary: #000329;
$text-primary: #ffffff;
$text-secondary: #cccccc;
$accent-color: #ffd700;
$card-bg: rgba(30, 41, 59, 0.7);
$shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
$transition: all 0.3s ease;

.quantify-page {
  background-image: url("~@/assets/images/bg/容器 2739.png");
  background-size: cover;
  background-repeat: no-repeat;
}

/* ========== 量化交易的本质 模块 ========== */
.essence-section {
  padding: 100px 0;
  background: transparent;
}

.essence-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.essence-title {
  font-size: 48px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 24px;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.essence-title .highlight {
  color: #ffd200;
}

.essence-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
  max-width: 700px;
  margin: 0 auto 60px;
}

.essence-visual {
  position: relative;
  width: 500px;
  height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.frame-container {
  width: 600px;
  height: 600px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  animation: frameAnimation 1.5s infinite steps(1);
}

@keyframes frameAnimation {
  0% {
    background-image: url("~@/assets/images/icons/容器 2575.png");
  }

  33.33% {
    background-image: url("~@/assets/images/icons/容器 2576.png");
  }

  66.66% {
    background-image: url("~@/assets/images/icons/容器 2577.png");
  }

  100% {
    background-image: url("~@/assets/images/icons/容器 2575.png");
  }
}

.feature-card {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 146px;
  height: 54px;
  padding: 6px 12px;
  background: linear-gradient(169deg, #1b1c3629 15%, #70717a29 68%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 22px;
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  cursor: pointer;
}

.feature-card:hover {
  box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);
  border-color: rgba(255, 255, 255, 0.4);
}

.card-icon-wrap {
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-icon-wrap img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.feature-card .card-text {
  font-size: 14px;
  color: #ffffff;
  font-weight: 500;
}

.card-trend {
  left: -20%;
  top: 50%;
  transform: translateY(-50%);
}

.card-factor {
  right: -20%;
  top: 15%;
}

.card-auto {
  right: -20%;
  bottom: 15%;
}

/* 响应式 */
@media (max-width: 991px) {
  .essence-section {
    padding: 60px 0;
  }

  .essence-title {
    font-size: 32px;
  }

  .essence-desc {
    font-size: 14px;
    padding: 0 20px;
  }

  .essence-visual {
    width: 350px;
    height: 280px;
  }

  .frame-container {
    width: 450px;
    height: 450px;
  }

  .feature-card {
    width: 100px;
    height: 36px;
    padding: 4px 10px;
    gap: 8px;
  }

  .card-icon-wrap {
    width: 26px;
    height: 26px;
  }

  .card-icon-wrap img {
    width: 14px;
    height: 14px;
  }

  .feature-card .card-text {
    font-size: 12px;
  }

  .card-trend {
    left: -5%;
    top: 45%;
  }

  .card-factor {
    right: -5%;
    top: 10%;
  }

  .card-auto {
    right: -5%;
    bottom: 10%;
  }
}

@media (max-width: 480px) {
  .essence-title {
    font-size: 26px;
  }

  .essence-desc {
    font-size: 13px;
  }

  .essence-visual {
    width: 300px;
    height: 250px;
  }
}

/* ========== 量化投资策略模块样式 ========== */
.strategy-section {
  padding: 100px 0;
  background: transparent;
}

.strategy-header {
  text-align: center;
  margin-bottom: 60px;
}

.strategy-tag {
  display: inline-block;
  padding: 8px 24px;
  border-radius: 22px;
  background: rgba(255, 210, 0, 0.2);
  border: 1px solid #ffd200;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 24px;
  color: #fff;
}

.strategy-title {
  font-size: 42px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 16px;
}

.strategy-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
}

.strategy-cards {
  display: flex;
  justify-content: center;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

/* ========== 量化投资策略卡片轮播（仅 H5 生效，桌面保持三栏） ========== */
.strategy-carousel {
  display: block;
}

.strategy-carousel .strategy-viewport {
  overflow: hidden;
}

.strategy-carousel .strategy-track {
  display: flex;
  justify-content: center;
  gap: 24px;
  transition: transform 0.4s ease;
}

.strategy-card {
  flex: 1;
  max-width: 360px;
  padding: 40px 30px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  text-align: center;
  transition: all 0.3s ease;
}

.strategy-card:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-5px);
  box-shadow: 0 0 25px rgba(255, 250, 220, 0.4);
}

.strategy-card.card-highlight {
  background: rgba(255, 255, 255, 0.05);
}

.strategy-card.card-highlight:hover {
  box-shadow: 0 0 25px rgba(255, 250, 220, 0.4);
  border-color: rgba(255, 255, 255, 0.4);
}

.strategy-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.strategy-icon svg {
  fill: #ffd200;
}

.strategy-card .card-title {
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 12px;
}

.strategy-card .card-desc {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
}

@media (max-width: 1024px) {
  .strategy-cards {
    flex-direction: column;
    align-items: center;
  }

  /* 平板：轮播容器内保持纵向堆叠（与原行为一致） */
  .strategy-carousel .strategy-track {
    flex-direction: column;
    align-items: center;
  }

  .strategy-card {
    max-width: 100%;
    width: 100%;
  }
}

@media (max-width: 991px) {
  .strategy-section {
    padding: 60px 0;
  }

  .strategy-title {
    font-size: 32px;
  }

  .strategy-card {
    padding: 30px 20px;
  }
}

/* ========== 产品矩阵模块 ========== */
.product-matrix-section {
  padding: 100px 0;
  background: transparent;
}

.matrix-title {
  font-size: 42px;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  margin-bottom: 60px;
}

.matrix-tabs {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 60px;
}

.matrix-tab {
  padding: 12px 30px;
  background: rgba(26, 31, 46, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 30px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.matrix-tab:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.4);
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
}

.matrix-tab.active {
  background: rgba(26, 31, 46, 0.8);
  border-color: #ffd200;
  border: 1px solid #ffe152;
  color: #fff;
  box-shadow: 0 0 25px rgba(255, 255, 220, 0.4);
}

.matrix-content {
  position: relative;
  background: #1a1f2e;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 100px 70px;
  padding-bottom: 100px;
}

.matrix-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: all 0.3s ease;
}

.matrix-nav.prev {
  left: 10px;
}

.matrix-nav.next {
  right: 10px;
}

.matrix-nav img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.matrix-nav:hover {
  transform: translateY(-50%) scale(1.1);
  filter: brightness(1.2);
}

.matrix-panel {
  display: flex;
  gap: 60px;
  align-items: center;
}

.panel-left {
  flex: 1;
}

.panel-title {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 20px;
}

.panel-desc {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.6;
  margin-bottom: 30px;
}

.panel-features {
  list-style: none;
  padding: 0;
  margin: 0;
}

.panel-features li {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.7);
  padding-left: 20px;
  position: relative;
}

.panel-features li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background: #6b7cff;
  border-radius: 50%;
}

.panel-right {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.forex-panel .panel-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 30px;
}

.forex-panel .chart-card {
  background: #1a1f2e;
  border: 1px solid #86909c;
  border-radius: 16px;
  padding: 24px;
  position: relative;
  width: 100%;
  height: 365px;
}

.forex-panel .chart-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.forex-panel .chart-icon {
  width: 53px;
  height: 53px;
  background: #ffd200;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.forex-panel .chart-title {
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
}

.forex-panel .chart-subtitle {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
}

.forex-panel .chart-stats-top {
  position: absolute;
  top: -24px;
  right: -24px;
  background: #1a1f2e;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 16px;
  min-width: 160px;
}

.forex-panel .chart-stats-top .stat-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.forex-panel .chart-stats-top .stat-item:last-child {
  margin-bottom: 0;
}

.forex-panel .chart-stats-top .stat-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  white-space: nowrap;
}

.forex-panel .chart-stats-top .stat-dots {
  display: flex;
  align-items: center;
  gap: 3px;
  flex: 1;
  padding: 0 6px;
}

.forex-panel .chart-stats-top .stat-dots .dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  flex-shrink: 0;
}

.forex-panel .chart-stats-top .stat-value {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
}

.forex-panel .chart-stats-top .stat-value.yellow {
  color: #ffd200;
}

.forex-panel .chart-image {
  width: 100%;
  height: 200px;
  margin: 20px 0;
  border-radius: 8px;
  overflow: hidden;
}

.forex-panel .chart-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.forex-panel .chart-stats-bottom {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 20px;
}

.forex-panel .chart-stats-bottom .stat-box {
  background: #1a1f2e;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 10px;
  text-align: center;
}

.forex-panel .chart-stats-bottom .stat-box-value {
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 4px;
  flex: 1;
}

.forex-panel .chart-stats-bottom .stat-box-value.small {
  font-size: 20px;
}

.forex-panel .chart-stats-bottom .stat-box-label {
  flex: 1;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 18px;
}

.forex-panel .chart-stats-bottom .stat-box-sublabel {
  flex: 1;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 4px;
}

/* 图表周围小盒子：触摸/悬停出现白色投影（与首页 touch-glow 一致） */
.forex-panel .chart-stats-top,
.forex-panel .chart-stats-bottom .stat-box {
  transition: box-shadow 0.3s ease, border-color 0.3s ease;
}

.forex-panel .chart-stats-top:hover,
.forex-panel .chart-stats-bottom .stat-box:hover {
  border-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0 0 25px rgba(255, 255, 255, 0.2);
}

@media (max-width: 1024px) {
  .matrix-panel {
    flex-direction: column;
  }

  .panel-left,
  .panel-right {
    width: 100%;
  }
}

@media (max-width: 991px) {
  .product-matrix-section {
    padding: 60px 0;
  }

  .matrix-title {
    font-size: 28px;
  }

  /* 三个头部导航在 H5 一行显示（内容自适应收缩，超长文案省略号兜底） */
  .matrix-tabs {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .matrix-tab {
    width: auto;
    min-width: 0;
    max-width: none;
    flex: 0 1 auto;
    padding: 10px 6px;
    font-size: 11px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .matrix-content {
    padding: 20px 14px;
  }

  /* 左右切换按钮：移到内容盒下方居中排列，不再覆盖图表/文字 */
  .matrix-navs {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 28px;
    margin-top: 16px;
  }

  .matrix-nav {
    position: static;
    width: 30px;
    height: 30px;
  }

  .matrix-nav:hover {
    transform: scale(1.1);
  }

  .panel-title {
    font-size: 24px;
    margin-bottom: 10px;
  }

  /* 竖排时文字块与图表间距收窄，整体盒子高度更接近截图比例 */
  .matrix-panel {
    gap: 20px;
  }

  .matrix-panel .panel-subtitle {
    margin-bottom: 14px;
  }
}

/* ========== 合作模式模块样式（按钮在卡片内部） ========== */
.cooperation-section {
  padding: 100px 0;
  background: transparent;
  position: relative;
  margin-bottom: 300px
}

.cooperation-header {
  text-align: center;
  margin-bottom: 60px;
}

.cooperation-tag {
  display: inline-block;
  padding: 8px 24px;
  border-radius: 20px;
  background: rgba(255, 210, 0, 0.2);
  border: 1px solid #ffd200;
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 24px;
}

.cooperation-title {
  font-size: 42px;
  font-weight: 700;
  color: #ffffff;
}

.cooperation-cards-wrapper {
  position: relative;
  max-width: 1256px;
  margin: 0 auto;
  min-height: 500px;
}

.cooperation-card {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  border-radius: 24px;
  overflow: hidden;
  transition: all 0.4s ease;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 0 30px #9986909c;
  border: 1px solid #ccc;
  display: flex;
  flex-direction: column;
}

.card-bg-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 31, 46, 0.8);
  border-radius: 24px;
  z-index: 1;
}

.cooperation-card-content {
  position: relative;
  z-index: 2;
  padding: 40px;

  flex: 1;
}

.card-security {
  top: 0;
  z-index: 1;
}

.card-support {
  top: 100px;
  z-index: 2;
}

.card-profit {
  top: 200px;
  z-index: 3;
}

/* 卡片图标（原有样式，保留备用） */
.cooperation-card-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.cooperation-card-icon.blue {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
}

.cooperation-card-icon.green {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
}

.cooperation-card-icon.yellow {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

.cooperation-card-icon img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.cooperation-card-title {
  font-size: 28px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 20px;

}

.cooperation-card-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.cooperation-card-list li {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 2;
  position: relative;
  padding-left: 20px;
}

.cooperation-card-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ffd200;
}

/* 查看更多按钮（外层容器统一绝对定位：图标居中显示在按钮上方 5px） */
.cooperation-more-wrap {
  position: absolute;
  bottom: 4px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  z-index: 5;
}

.cooperation-more-icon {
  display: block;
  width: 24px;
  height: auto;
  margin: 0 auto 0px;

}

.cooperation-more-btn {
  display: block;
  width: 200px;
  margin: 0 auto;
  margin-top: 0px;
  padding: 15px 30px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 30px;
  color: #ffffff;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.cooperation-more-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
}

/* 响应式 */
@media (max-width: 991px) {
  .cooperation-section {
    padding: 60px 0;
  }

  .cooperation-title {
    font-size: 28px;
  }

  .cooperation-cards-wrapper {
    min-height: 400px;
  }

  .cooperation-card {
    width: 95%;
  }

  .cooperation-card-content {
    padding: 24px;
  }

  .cooperation-card-title {
    font-size: 22px;
  }

  .card-support {
    top: 20px;
  }

  .card-profit {
    top: 40px;
  }

  .cooperation-more-btn {
    padding: 12px 30px;
    font-size: 14px;
    margin: 0 auto;
  }
}

/* ========== 统一卡片样式（资金安全，陪伴辅导，阳光分润 同步复用） ========== */
.card-security,
.card-support,
.card-profit {
  min-height: 380px;

  .cooperation-card-content {
    display: flex;
    justify-content: space-between;

    gap: 40px;
    padding: 70px 60px;
    height: 100%;
    align-items: center;
  }

  /* 左侧列表区 */
  .security-left {
    flex: 1;
    position: relative;
    padding-left: 50px;

  }

  /* 标题部分绝对定位，且修复了原有的错位问题 */
  .security-header {
    position: absolute;
    top: -20px;
    left: -20px;
    display: flex;
    align-items: center;
    gap: 12px;
    // background: #1a1f2e;
    padding: 0 10px 0 0;
    margin-bottom: 0;

    .security-icon-wrap {
      width: 40px;
      height: 40px;
      background: #1a1f2e;
      border: 2px solid #3b82f6;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 10px rgba(59, 130, 246, 0.5);

      img {
        width: 18px;
        height: 18px;
        object-fit: contain;
      }
    }

    .cooperation-card-title {
      margin: 0;
      font-size: 28px;
      position: static;
      top: auto;
      left: auto;
      width: 400px;
      position: absolute;
      top: 0px;
      left: 70px;
    }
  }

  /* 列表详情 */
  .security-list {
    margin-top: 40px;
    list-style: none;
    padding: 0;
  }

  .security-list li {
    display: flex;
    gap: 15px;
    margin-bottom: 24px;
    position: relative;
    padding-left: 0;

    &::before {
      display: none;
    }
  }

  .security-list .num {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(59, 130, 246, 0.2);
    color: #3b82f6;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .security-list .text strong {
    display: block;
    font-size: 18px;
    color: #ffffff;
    margin-bottom: 6px;
  }

  .security-list .text p {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.6;
    margin: 0;
  }

  /* 右侧图片区 */
  .security-right {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      max-width: 100%;
      height: auto;
      object-fit: contain;
    }
  }

  /* 覆盖底部的查看更多按钮 */
  .cooperation-more-btn {
    width: auto;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    font-size: 14px;
    padding: 10px;
    margin: 0 auto;
        padding-top: 0px;

    &:hover {
      color: #ffd200;
      box-shadow: none;
      background: transparent;
    }
  }
}

/* 响应式调整 */
@media (max-width: 991px) {

  .card-security,
  .card-support,
  .card-profit {
    .cooperation-card-content {
      flex-direction: column;
      /* H5 隐藏下方图片后文字区加些内边距 */
      padding: 36px 28px;
    }

    /* H5 隐藏卡片下方图片 */
    .security-right {
      display: none;
    }
  }
}

/* ========== 信任与行动模块（适配 CTA and Footer.png 背景） ========== */
.trust-cta-section {
  background-image: url("~@/assets/images/bg/CTA and Footer.png");
  background-size: 1500px auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  padding: 200px 0 180px;
  position: relative;
  overflow: hidden;
  height: 800px;

  &::before {
    display: none;
  }
}

.trust-cta-content {
  position: relative;
  z-index: 1;
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
}

.trust-cta-title {
  font-size: 52px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 20px;
  line-height: 1.2;
  letter-spacing: 2px;
  text-shadow: 0 2px 30px rgba(0, 0, 0, 0.3);
}

.trust-cta-title .highlight {
  color: #ffd200;
  &::after {
    display: none;
  }
}

.trust-cta-subtitle {
  font-size: 22px;
  color: #ffd200;
  margin-bottom: 50px;
  letter-spacing: 6px;
  font-weight: 300;
}

.trust-cta-btn-wrap {
  margin-top: 50px;
  display: inline-flex;
  padding: 12px;
  background: rgba(255, 210, 0, 0.3);
  border: 1px solid #ffd200;
  border-radius: 60px;
  transition: all 0.35s ease;

  &:hover,
  &:active {
    background: #ffd200;
  }
}

.trust-cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 15px 10px;
  background: #ffd200;
  border: none;
  border-radius: 50px;
  width: 200px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: all 0.35s ease;
  box-shadow: 0 0 30px rgba(255, 210, 0, 0.5);
  position: relative;

  &:hover {
    transform: translateY(-3px) scale(1.02);
    box-shadow: 0 0 50px rgba(255, 210, 0, 0.7);
  }

  &:active {
    transform: scale(0.97);
  }

  &::after {
    content: "↗";
    font-size: 20px;
    font-weight: 700;
    margin-left: 10px;
    font-family: sans-serif;
    position: relative;
    top: -1px;
  }
}

/* ========== 响应式 ========== */
@media (max-width: 991px) {
  .trust-cta-section {
    padding: 60px 0 40px;
  }

  .trust-cta-title {
    font-size: 32px;
  }

  .trust-cta-subtitle {
    font-size: 18px;
    letter-spacing: 2px;
    margin-bottom: 30px;
  }

  .trust-cta-btn-wrap {
    padding: 8px;
  }

  .trust-cta-btn {
    padding: 14px 40px;
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .trust-cta-title {
    font-size: 26px;
  }

  .trust-cta-subtitle {
    font-size: 16px;
    letter-spacing: 1px;
  }

  .trust-cta-btn-wrap {
    padding: 6px;
  }

  .trust-cta-btn {
    padding: 12px 32px;
    font-size: 14px;
    width: 100%;
    max-width: 280px;
  }
}

/* ========== 新增：投资理念模块卡片背景图 ========== */
.investment-philosophy-section .strategy-card {
  background-image: url("~@/assets/images/bg/gradient.png");
  // background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-blend-mode: overlay;
}

.investment-philosophy-section .strategy-card:hover {
  background-color: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-5px);
  box-shadow: 0 0 25px rgba(255, 250, 220, 0.4);
}

/* ========== H5 适配补充（不影响桌面端） ========== */
@media (max-width: 991px) {
  /* 信任CTA：桌面固定 800px 高，移动端改为自适应并让背景图完整缩放 */
  .trust-cta-section {
    height: auto;
    min-height: 480px;
    background-size: cover;
    background-position: center bottom;
    padding: 100px 0 60px;
  }

  /* 产品矩阵：H5 统一 文字在上、图表在下（覆盖第2个面板 图表在前的 DOM 顺序） */
  .matrix-panel {
    flex-direction: column;
  }

  .matrix-panel .panel-left {
    order: 1;
    width: 100%;
  }

  .matrix-panel .panel-right {
    order: 2;
    width: 100%;
  }

  /* 图表卡片：恢复桌面「浮动盒子」布局（截图样式），字体/图表相对缩小 */
  .forex-panel .chart-card {
    height: auto;
    padding: 16px 14px;
  }

  /* 年化/月化收益率卡：改为标题下方通栏横条。
     原先浮动右上角，英文标签较长时盒子被撑宽（省略点 flex:1 + nowrap），
     会盖住标题和图表；改为文档流内横条后任何语言都不遮挡内容 */
  .forex-panel .chart-stats-top {
    position: static;
    display: flex;
    gap: 12px;
    min-width: 0 !important;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 4px;
    padding: 8px 12px !important;
  }

  .forex-panel .chart-stats-top .stat-item {
    flex: 1;
    min-width: 0;
    flex-wrap: wrap;
    margin-bottom: 0;
  }

  /* 中间的省略点在 H5 隐藏，避免英文长标签把盒子撑宽 */
  .forex-panel .chart-stats-top .stat-dots {
    display: none;
  }

  .forex-panel .chart-stats-top .stat-label {
    font-size: 10px;
  }

  .forex-panel .chart-stats-top .stat-value {
    font-size: 12px;
  }

  .forex-panel .chart-header {
    gap: 10px;
    margin-bottom: 10px;
  }

  .forex-panel .chart-icon {
    width: 40px;
    height: 40px;
  }

  .forex-panel .chart-title {
    font-size: 14px;
  }

  .forex-panel .chart-subtitle {
    font-size: 10px;
  }

  .forex-panel .chart-image {
    height: 150px;
    margin: 12px 0;
  }

  /* 底部两个统计盒：一行并排缩小版（覆盖行内宽高/字号需 !important） */
  .forex-panel .chart-stats-bottom {
    flex-wrap: nowrap;
    gap: 10px;
    margin-top: 12px;
  }

  .forex-panel .chart-stats-bottom .stat-box {
    width: auto !important;
    height: auto !important;
    min-height: 0;
    flex: 1;
    box-sizing: border-box;
    padding: 8px;
  }

  .forex-panel .chart-stats-bottom .stat-box-value {
    font-size: 18px !important;
  }

  .forex-panel .chart-stats-bottom .stat-box-value.small {
    font-size: 16px !important;
  }

  .forex-panel .chart-stats-bottom .stat-box-label {
    font-size: 11px !important;
    line-height: 16px;
  }

  .forex-panel .chart-stats-bottom .stat-box-sublabel {
    font-size: 9px !important;
  }

  /* 投资理念上下留白收窄（覆盖行内 margin: 200px 0） */
  .investment-philosophy-section {
    margin: 80px 0 !important;
  }

  /* 合作模式：移动端卡片改为常规流式堆叠。
     桌面端卡片绝对定位（top 0/70/140），高度靠 margin-bottom 预留；
     移动端卡片实际高度远超容器 min-height，会压到下方模块，
     改为 static 流式后高度随内容自适应，彻底消除重叠 */
  .cooperation-section {
    margin-bottom: 0;
  }

  .cooperation-cards-wrapper {
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .cooperation-card {
    position: static;
    transform: none;
    width: 100%;
  }

  /* ========== 统一 H5 字号：模块大标题 20px，副标题/描述 12px ========== */
  /* 大标题 */
  .essence-title,
  .strategy-title,
  .matrix-title,
  .panel-title,
  .cooperation-title,
  .cooperation-card-title,
  .trust-cta-title {
    font-size: 20px !important;
  }

  /* 副标题 / 描述文本 */
  .essence-desc,
  .strategy-subtitle,
  .forex-panel .panel-subtitle,
  .strategy-card .card-desc,
  .security-list .text p,
  .trust-cta-subtitle {
    font-size: 12px !important;
    line-height: 1.6;
  }

  /* 卡片标题 & 列表标题 */
  .strategy-card .card-title {
    font-size: 16px;
  }
  .security-list .text strong {
    font-size: 15px;
  }
  .panel-features li {
    font-size: 13px;
  }
}

/* 覆盖 480px 中对 trust-cta 的旧字号设置 */
@media (max-width: 480px) {
  .essence-title,
  .trust-cta-title {
    font-size: 20px !important;
  }
  .essence-desc,
  .trust-cta-subtitle {
    font-size: 12px !important;
  }
}

/* ========== 量化投资策略：H5 三卡片改轮播（自动播放，无导航按钮） ========== */
@media (max-width: 991px) {
  .strategy-carousel .strategy-track {
    flex-direction: row;
    align-items: stretch;
    /* 左对齐：继承的 center 会把溢出量平分到两侧，导致第一张卡被推到左边看不见 */
    justify-content: flex-start;
    /* 去掉间隙：避免 translateX(-100%) 位移后上一张卡片露边（会同时看到两张卡） */
    gap: 0;
  }

  .strategy-carousel .strategy-card {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

/* ========== 投资理念：H5 三卡片改轮播（与量化投资策略同款） ==========
   桌面/平板：viewport 与 track 用 display:contents 退出布局，
   卡片仍是 .strategy-cards 的直接 flex 子项，三栏/纵向堆叠行为不变 */
.philo-carousel .philo-viewport {
  display: contents;
}

.philo-carousel .philo-track {
  display: contents;
}

@media (max-width: 991px) {
  .philo-carousel .philo-viewport {
    display: block;
    overflow: hidden;
    width: 100%;
  }

  /* 左对齐 + 无间隙：继承 center 会把溢出平分到两侧导致首卡被裁，
     gap 会让 translateX(-100%) 位移后上一张卡片露边 */
  .philo-carousel .philo-track {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    gap: 0;
    transition: transform 0.4s ease;
  }

  .philo-carousel .strategy-card {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>